import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

interface BlogCardProps {
  title: string;
  excerpt: string;
  author: string;
  date: string;
  imageUrl?: string | undefined;
  slug: string;
}

export const BlogCard: React.FC<BlogCardProps> = ({
  title,
  excerpt,
  author,
  date,
  imageUrl,
  slug,
}) => {
  return (
    <Link
      to={slug}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-dark-bg text-white flex flex-col hover:bg-white/[0.03] transition-colors duration-200 group p-6"
    >
      {imageUrl && (
        <div className="mb-5 overflow-hidden rounded-md h-44 bg-white/5">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300"
          />
        </div>
      )}

      <div className="flex-grow">
        <p className="text-xs uppercase tracking-widest text-white/40 mb-3">
          {author}
        </p>
        <h3 className="text-sm font-semibold text-white leading-snug mb-3 group-hover:text-[#00A3FF] transition-colors duration-200">
          {title}
        </h3>
        <p className="text-white/50 text-xs leading-relaxed line-clamp-3">
          {excerpt}
        </p>
      </div>

      <div className="flex items-center justify-between mt-5 pt-4 border-t border-white/10">
        <span className="text-xs text-white/30">{date}</span>
        <ArrowUpRight
          size={14}
          className="text-white/30 group-hover:text-[#00A3FF] transition-colors duration-200"
        />
      </div>
    </Link>
  );
};
